import { createSlice } from '@reduxjs/toolkit';
import adhieData from '../adhie-anna.json';

const gallerySlice = createSlice({
  name: 'gallery',
  initialState: adhieData,
  reducers: {
    setGalleryData: (state, action) => {
      return action.payload;
    },
  },
});

export const { setGalleryData } = gallerySlice.actions;
export default gallerySlice.reducer;
